import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { CanActivate } from '@angular/router';
import { UserService } from '../services/user.service';
import { EnvService } from 'src/app/env.service';

@Injectable()
export class AuthGuard implements CanActivate {

  constructor(private userService: UserService, private router: Router, private env: EnvService) { }

  canActivate = (): boolean => {
    var jwt = sessionStorage.getItem(this.env.jwt);
    var loggedIn = jwt;

    if (loggedIn) {
      return true;
    }
    else {
      this.router.navigate(['/login']);
    }
  }
}
